import logo from "./Logo.png";

const Header = () => {
  const handleHamburgerClick = () => {
    const menu = document.querySelector(".hamburger-menu");
    menu.classList.toggle("hidden");
  };
  const handleMenuItemsClick = (itemId) => {
    window.location.href = itemId;
    handleHamburgerClick();
  };
  return (
    <>
      <nav className="w-5/6 container flex justify-between py-10 mb-12 mx-auto items-center">
        <img
          src={logo}
          alt="Nabeel Dev Portfolio"
          width="60px"
          className="cursor-pointer"
          onClick={() => (window.location.href = "#")}
        />

        <ul className="hidden md:flex mx-auto">
          <li className="ml-10">
            <a
              title="Goto Home"
              href="#home"
              className="text-white hover:bg-gray-700 px-4 py-2  hover:text-gray-100 rounded-md text-md font-medium"
            >
              Home
            </a>
          </li>
          <li>
            <a
              title="View Nabeel's Skills"
              href="#skills"
              className="text-white hover:bg-gray-700 px-4 py-2 hover:text-gray-100 rounded-md text-md font-medium"
            >
              Skills
            </a>
          </li>
          <li>
            <a
              title="View Nabeel's Experience"
              href="#experience"
              className="text-white hover:bg-gray-700 px-4 py-2 hover:text-gray-100 rounded-md text-md font-medium"
            >
              Experience
            </a>
          </li>
          <li>
            <a
              title="Contact Nabeel"
              href="#contact"
              className="text-white hover:bg-gray-700 px-4 py-2 hover:text-gray-100 rounded-md text-md font-medium"
            >
              Contact
            </a>
          </li>
        </ul>
        <div className="flex gap-4">
          <button
            type="button"
            title="View Nabeel's Resume"
            className="flex text-white hover:text-gray-50 hover:from-teal-600 hover:to-cyan-600 px-5 py-3 bg-gradient-to-r from-cyan-600 to-teal-600 rounded-xl font-medium"
            onClick={() =>
              window.open("https://gmnabeel.github.io/resume/Resume.pdf")
            }
          >
            Resume
          </button>

          <button
            className="md:hidden items-center px-4 py-3 border-2 rounded-lg text-teal-500 border-teal-600 hover:text-gray-100 hover:border-gray-100"
            onClick={handleHamburgerClick}
          >
            <svg
              className="fill-current h-4 w-4"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
      </nav>
      <div className="hamburger-menu hidden md:hidden top-28 p-5 bg-black w-screen absolute h-screen">
        <div className="flex flex-col bg-gray-900 border-2 border-gray-600 rounded-lg">
          <button
            title="Goto Home"
            className="text-white text-left p-5 hover:text-teal-300 block"
            onClick={() => handleMenuItemsClick("#home")}
          >
            Home
          </button>
          <button
            title="View Nabeel's Skills"
            className="text-white text-left p-5 hover:text-teal-300 block"
            onClick={() => handleMenuItemsClick("#skills")}
          >
            Skills
          </button>
          <button
            title="View Nabeel's Experience"
            className="text-white text-left p-5 hover:text-teal-300 block"
            onClick={() => handleMenuItemsClick("#experience")}
          >
            Experience
          </button>
          <button
            title="Contact Nabeel"
            className="text-white text-left p-5 hover:text-teal-300 block"
            onClick={() => handleMenuItemsClick("#contact")}
          >
            Contact
          </button>
        </div>
      </div>
    </>
  );
};
export default Header;
